<template>
    <div class="homePage">
        <el-carousel id="carousel" :style="{width: clientWidth + 'px', height: clientHeight + 'px'}" @change="carouselChange" :autoplay="autoplay" trigger="click" class="wow animate__fadeInLeftBig">
            <el-carousel-item v-for="(v, i) in carouselList" :key="i">
                <video class="video" :poster="poster" :id="`video-${i}`" v-if="isVideo(v.path)" @play="autoplay = false" @ended="autoplay = true" autoplay style="width: 100%;height:100%;object-fit:fill" muted>
                    <source :src="imgUrlHttp + v.path">
                </video>
                <!-- <div v-else :style="'background:url('+ imgUrlHttp + v.path +') no-repeat; background-size: 100% 100%;'" @click="jumpOther(v.link)" style="width: 100%; height:100%"></div> -->
                <img :src="imgUrlHttp + v.path" style="width: 100%; height:100%; display: block;">
            </el-carousel-item>
        </el-carousel>
        <div class="now_buy">
            <img src="../assets/pc_tu.png" class="wow animate__fadeInRightBig">
            <a href="https://qianyezhubao.tmall.com/?fr=keer" target="_blank" class="link"></a>
        </div>
        <div class="main">
            <div class="findStoreBox" ref="findStoreBox" id="czmd">
                <div class="top">探索线下精品门店</div>
                <div class="bottom">
                    <div class="left">
                        <div class="title">在以下范围内查找</div>
                        <baidu-map class="mapBox" ref="BMap" :center="center" :zoom="zoom" @ready="mapInitHandler" @click="getClickInfo" :scroll-wheel-zoom="true"></baidu-map>
                    </div>
                    <div class="right">
                        <div class="searchBox">
                            <div class="selecterBox">
                                <el-cascader class="selecter" :placeholder="currentCity" :options="options" v-model="selectedOptions" @change="handleChange"></el-cascader>
                                <i class="iconfont iconarrow_down_full"></i>
                            </div>
                            <div class="selecterBox">
                                <el-select class="selecter" v-model="currentDistance" :placeholder="currentDistance">
                                    <el-option v-for="(v, i) in distanceList" :key="i" :label="v" :value="v"></el-option>
                                </el-select>
                                <i class="iconfont iconarrow_down_full"></i>
                            </div>
                        </div>
                        <div class="searchResult">
                            <div class="cityName">{{currentCity}}</div>
                            <div class="store" v-for="(store, idx) in currentStoreLsit" :key="key+idx">
                                <div>{{store.name}}</div>
                                <div @click="toBaiduMap(store)">
                                    <span class="text-nowrap">{{store.address}}</span>
                                    <i class="iconfont iconiconfontjiantou5"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottomBox" ref="bottomBox" id="ppgs">
                <div class="top">千叶珠宝王国</div>
                <div class="bottom">
                    <div class="left">
                        <div class="mapBox" id="rollTextBox">
                            <div class="title">美的见证</div>
                            <p>美好的事物从来都是对美的不懈追求。KEER，源自荷兰语“时间”，代表美的永恒。2001年以来，千叶珠宝甄选上乘珠宝和材质，采用独具匠心的精雕工艺，以“优雅、浪漫、温婉、灵动”的设计理念，诠释了东方女性独特之美，成为时下亚洲女性轻奢珠宝首选。</p>
                            <p>千叶珠宝自2001年，由中国珠宝玉石协会常务理事林明杰先生创办以来，始终追求珠宝的精美和灵感内涵，将传递美与爱视为信仰。2015年挂牌上市，荣膺“亚洲品牌500强”、“中国企业成长百强”等多项荣誉，成为纽约时装周挚爱之选。</p>
                            <div class="title">匠心之美</div>
                            <p>每一件千叶珠宝的诞生，都离不开独具匠心的工艺。千叶珠宝运用领先全球的核心技术，为千叶珠宝缔造了恒久品质和品牌美誉。</p>
                            <div class="title">千叶珠宝设计师</div>
                            <p>千叶珠宝特别聘请来自艺术之都巴黎、意大利等欧洲先锋设计师，将玩味革新的设计融入千叶珠宝设计中，打造精致迷人的轻奢珠宝。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
    ak: "4GhbbUnM8oxSmMpe0jW9KLazGptyNmGE",
});
import {
    Carousel,
    CarouselItem,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Cascader,
    Option,
    Select,
} from "element-ui";
import { WOW } from "wowjs";
import { banners, stores, cities } from "@/utils/request";
import { space, setStorage, staticHost } from "@/utils/tool.js";
import { provinceAndCityData, CodeToText } from "element-china-area-data";
import area from "@/utils/area.js";

const app_key = "cf679404652ceec7fd8824a79db7ea07";

export default {
    name: "Home",
    components: {
        [Carousel.name]: Carousel,
        [CarouselItem.name]: CarouselItem,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
        [Cascader.name]: Cascader,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    computed: {
        key() {
            return `${Date.now()}-${Math.random()}`;
        },
        currentStoreLsit() {
            let markers = this.storeList;
            if (this.currentCity !== "城市") {
                markers = this.storeList.filter((v) => this.currentCity.startsWith(v.city));
            } else {
                markers = this.storeList;
            }
            if (this.currentDistance !== "半径") {
                let radius = Number.parseInt(this.currentDistance);
                markers = markers.filter(
                    (v) =>
                        space(this.center.lat, this.center.lng, +v.latitude, +v.longitude) <= radius
                );
            }
            return markers;
        },
    },
    watch: {
        currentStoreLsit() {
            this.setStoreMarker();
        },
        scrollTop(newVal, oldVal) {
            if (newVal > 0) {
                document.getElementById("rollTextBox").scrollTop = newVal;
            }
        },
    },
    data() {
        return {
            carouselList: [],
            imgUrlHttp: "",
            center: { lng: 104.06792346, lat: 30.67994285 },
            zoom: 10,
            storeList: [],
            currentCity: "城市",
            currentDistance: "半径",
            showCityPicker: false,
            showDistancePicker: false,
            distanceList: ["1公里", "2公里", "5公里", "10公里", "20公里"],
            cityList: [],
            map: null,
            BMap: null,
            autoplay: true,
            currentIndex: 0,
            poster: require("@/assets/p.jpg"),
            options: provinceAndCityData,
            selectedOptions: [],
            clientWidth: 1340,
            clientHeight: 0,
            scrollTimer: null,
            scrollTop: 0,
            offsetY: 0,
            bannerSize: {
                width: 1920,
                height: 680
            }
        };
    },
    created() {
        this.init();
        this.clientWidth = document.body.clientWidth;
        this.imgUrlHttp = staticHost()
        this.clientHeight = ((document.body.clientWidth * this.bannerSize.height) / this.bannerSize.width)
        window.addEventListener("resize", () => {
            this.clientWidth = document.body.clientWidth;
            this.clientHeight = ((document.body.clientWidth * this.bannerSize.height) / this.bannerSize.width)
        });
    },
    mounted() {
        this.$nextTick(() => {
            const wow = new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                offset: 0,
                mobile: true,
                live: false,
            });
            wow.init();
        });
        document.getElementById("rollTextBox").addEventListener("mouseover", (e) => {
            if (!this.scrollTimer) {
                this.scrollTimer = window.setInterval(() => {
                    this.scrollTop += 0.5;
                }, 10);
            }
        });
        document.getElementById("rollTextBox").addEventListener("mouseout", (e) => {
            window.clearInterval(this.scrollTimer);
            this.scrollTimer = null;
            if (this.scrollTop === -1) {
                this.scrollTop = this.offsetY;
            }
        });
        document.getElementById("rollTextBox").addEventListener("mousewheel", (e) => {
            window.clearInterval(this.scrollTimer);
            this.scrollTimer = null;
            this.scrollTop = -1;
            this.offsetY = document.getElementById("rollTextBox").scrollTop;
        });
        
    },
    methods: {
        init() {
            this.getBanners();
            this.getStores();
            this.getCityList();
            this.getLocationCityName();
        },
        handleChange(value) {
            const cityName = area.city_list[value[1]];
            this.getCityCenter(cityName);
            this.currentCity = cityName;
        },
        draw(point, map, el) {
            console.log(point, map, el);
        },
        mapInitHandler({ BMap, map }) {
            this.BMap = BMap;
            this.map = map;
            var geolocation = new BMap.Geolocation();
            this.location(geolocation, map);
            // this.getData(map, BMap);
            // 添加鼠标滚动缩放
            map.enableScrollWheelZoom();
            // 添加缩略图控件
            map.addControl(
                new BMap.OverviewMapControl({ isOpen: false, anchor: BMAP_ANCHOR_BOTTOM_RIGHT })
            );
            // 添加缩放平移控件
            map.addControl(new BMap.NavigationControl());
        },
        getClickInfo(e) {
            console.log(e.point.lng);
            console.log(e.point.lat);
            // this.center.lng = e.point.lng;
            // this.center.lat = e.point.lat;
        },
        // 定位
        location(geo, map) {
            var self = this;
            geo.getCurrentPosition(function (r) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    var mk = new self.BMap.Marker(r.point);
                    map.addOverlay(mk);
                    var circle = new self.BMap.Circle(r.point, 6, {
                        strokeColor: "Red",
                        strokeWeight: 6,
                        strokeOpacity: 1,
                        Color: "Red",
                        fillColor: "#f03",
                    });
                    map.addOverlay(circle);
                    map.panTo(r.point);
                    self.center.lat = r.point.lat;
                    self.center.lng = r.point.lng;
                    self.setStoreMarker();
                    // console.log("location===>" + JSON.stringify(self.center));
                }
            });
        },
        async getBanners() {
            const { success, resultObject } = await banners();
            success ? (this.carouselList = resultObject) : null;
        },
        // 获取定位城市名
        async getLocationCityName() {
            const { data } = await this.$http.get(`https://restapi.amap.com/v3/ip?key=${app_key}`);
            if (data.status === "1" && data.city) {
                this.currentCity = data.city;
            }
        },
        // 获取店铺列表
        async getStores() {
            const { success, resultObject } = await stores();
            if (success) {
                this.storeList = resultObject.filter((v) => {
                    return v.latitude !== null && v.longitude !== null;
                });
            } else {
                this.$toast("服务器异常，请稍后再试");
            }
        },
        // 获取城市列表
        async getCityList() {
            const { success, resultObject } = await cities();
            success ? (this.cityList = resultObject) : null;
        },
        // 获取城市经纬度 移动地图
        async getCityCenter(keywords) {
            const { data, status } = await this.$http.get(
                `https://restapi.amap.com/v3/config/district?key=${app_key}&keywords=${keywords}&subdistrict=0`
            );
            if (data && data.districts && data.districts.length) {
                let center = {
                    lng: +data.districts[0].center.split(",")[0],
                    lat: +data.districts[0].center.split(",")[1],
                };
                this.center = center;
                this.setStoreMarker();
            } else {
                console.log("获取城市坐标失败，请稍候再试");
            }
        },
        // 设置店铺标记
        setStoreMarker() {
            try {
                this.map.clearOverlays();
            } catch (error) {}
            const icon = new this.BMap.Icon(
                "http://www.keerworld.com/static/keer/resources/vue/1596215945731.png",
                new BMap.Size(25, 25)
            );

            var mk = null;
            this.currentStoreLsit.forEach((v) => {
                var mk = new this.BMap.Marker(
                    { lng: +v.longitude, lat: +v.latitude },
                    { icon: icon }
                );
                this.map.addOverlay(mk);
            });
            this.setCenterMarker();
        },
        toBaiduMap({ address, name, latitude, longitude }) {
            window.open(`http://api.map.baidu.com/geocoder?address=${address}&output=html&src=yq`);
        },
        setCenterMarker() {
            var mk = new this.BMap.Marker(this.center);
            this.map.addOverlay(mk);
        },
        isVideo(v) {
            return v.indexOf(".mp4") !== -1;
        },
        carouselChange(i, idx) {
            this.currentIndex = i;
            if (this.isVideo(this.carouselList[i].path)) {
                let video = document.getElementById(`video-${i}`);
                video.play();
                video.currentTime = 0
                let videos = Array.from(document.getElementsByClassName("video"));
                videos.forEach((v) => {
                    if (v.getAttribute("id") !== `video-${i}`) {
                        v.pause();
                    }
                });
            }
        },
        jumpOther(url) {
            if (url) {
                window.location.href = url;
            }
        },
    },
    beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.homePage {
    min-height: calc(100vh - 1rem);
    width: 100%;
    background: #ffffff;
    overflow-x: hidden;
    #carousel{ overflow-y:hidden;}
    ::v-deep {
        .anchorBL {
            display: none;
        }
        .BMap_cpyCtrl {
            display: none;
        }
        .el-dropdown-selfdefine {
            color: #000000;
        }
        .el-dropdown-menu {
            height: 1rem;
            overflow: hidden;
        }
    }
    .now_buy{
        position: relative;
        width: 100%;
        img {
            width: 100%;
        }
        .link{
            width: 15%;
            height: 100%;
            position: absolute;
            top: 0;
            right: 18.8%;
        }
    }
    .main {
        background: url("../assets/index_main.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .top {
        font-size: .27rem;
    }
    .findStoreBox {
        margin-top: -0.1rem;
        width: 100%;
        height: 4.74rem;
        padding: 0.4rem 0.66rem 0.4rem 0.92rem;
        font-size: 0.352rem;
        > .bottom {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            width: 100%;
            > .left {
                > .title {
                    font-size: 0.16rem;
                    padding: 0.1rem 0;
                }
                > .mapBox {
                    height: 3.3rem;
                    width: 3.5rem;
                    overflow: hidden;
                    margin-top: 0.1rem;
                }
            }
            > .right {
                height: 3.7rem;
                width: 4rem;
                overflow-y: auto;
                font-size: 0.15rem;
                .searchBox {
                    font-size: 0.15rem;
                    width: 100%;
                    position: sticky;
                    top: 0;
                    left: 0;
                    background-color: #ffffff;
                    display: flex;
                    align-items: center;
                    padding-bottom: 0.1rem;
                    .selecterBox {
                        position: relative;
                        > i {
                            position: absolute;
                            right: 0.3rem;
                            top: 50%;
                            z-index: -1;
                            transform: translateY(-50%);
                            font-size: 0.15rem;
                            font-size: .1rem;
                        }
                        @media screen and (max-width: 450px) {
                            > i {
                                // top: 80%;
                                transform: translateY(-30%);
                            }
                        }
                    }
                    .selecter:first-child {
                        margin-right: 0.2rem;
                    }
                    .selecter {
                        height: 100%;
                        flex: 1;
                        // margin-top: .12rem;
                        // @media screen and (max-width: 375px) {
                        //     margin-top: -.05rem;
                        // }
                        ::v-deep {
                            .el-cascader-panel {
                                font-size: 0.1rem !important;
                            }
                            .el-input__inner {
                                border: 1px solid #000;
                                background-color: transparent !important;
                                height: 0.25rem;
                                line-height: 0.25rem;
                                font-size: 0.15rem;
                            }
                            .el-input .el-input__inner:focus,
                            .el-cascader .el-input.is-focus .el-input__inner {
                                border-color: #000 !important;
                                background: transparent !important;
                            }
                            .el-input__suffix {
                                display: none;
                            }
                        }
                    }
                }
                .searchResult {
                    width: 100%;
                    margin-bottom: 0.2rem;
                    .cityName {
                        font-size: 0.2rem;
                        font-weight: 600;
                        margin-bottom: 0.2rem;
                    }
                    > .store {
                        margin-bottom: 0.2rem;
                        > div:nth-child(1) {
                            margin-bottom: 0.08rem;
                            font-size: 0.13rem;
                            font-weight: 600;
                        }
                        > div:nth-child(2) {
                            color: #6a686e;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            font-size: 0.13rem;
                            i {
                                font-size: 0.13rem;
                                margin-left: 0.07rem;
                            }
                        }
                    }
                    > .store:hover {
                        cursor: pointer;
                    }
                }
            }
            > .right::-webkit-scrollbar {
                width: 0.03rem;
            }
            > .right::-webkit-scrollbar-thumb {
                border-radius: 0.03rem;
                background: #c5c5c5;
            }
            > .right::-webkit-scrollbar-track {
                border-radius: 0.03rem;
                background: #f5f5f5;
            }
        }
    }
    .bottomBox {
        width: 100%;
        height: 5.6rem;
        padding: 0.4rem 0.66rem 0.4rem 0.92rem;
        font-size: 0.352rem;
        > .bottom {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            width: 100%;
            padding-top: 0.4rem;
            > .left {
                > .mapBox {
                    height: 2.8rem;
                    width: 3.5rem;
                    overflow-y: auto;
                    > .title {
                        font-size: 0.16rem;
                        padding: 0.1rem 0;
                    }
                    > p {
                        font-size: 0.12rem;
                        line-height: 0.25rem;
                        letter-spacing: 0.011rem;
                        margin-bottom: 0.1rem;
                        color: #4c4948;
                    }
                }
                > .mapBox::-webkit-scrollbar {
                    width: 0.03rem;
                }
                > .mapBox::-webkit-scrollbar-thumb {
                    border-radius: 0.03rem;
                    background: #c5c5c5;
                }
                > .mapBox::-webkit-scrollbar-track {
                    border-radius: 0.03rem;
                    background: #f5f5f5;
                }
            }
        }
    }
    ::v-deep {
        .el-carousel__button {
            background: #5ac5bf !important;
        }
        .el-carousel__indicator--horizontal {
            padding: 0.2rem 4px;
            .el-carousel__button {
                width: 0.3rem;
                height: 0.033rem;
            }
        }
        .el-carousel__arrow {
            width: 0.4rem;
            height: 0.4rem;
            font-size: 0.2rem;
        }
        .el-carousel__container {
            width: 100%;
            height: 100%;
            margin-bottom: 0.02rem;
            .el-carousel__item {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
